var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"profile-image bg-white-90 rounded-pill border-burgundy border",style:(_vm.style)},[_c('img',{staticStyle:{"opacity":"0"},attrs:{"src":this.src || '/img/profile.svg',"width":"100%","height":"100%"}})])}
var staticRenderFns = []

export { render, staticRenderFns }